import { render, staticRenderFns } from "./PointFilterLink.vue?vue&type=template&id=2acae230&scoped=true&"
import script from "./PointFilterLink.vue?vue&type=script&lang=js&"
export * from "./PointFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acae230",
  null
  
)

export default component.exports